export default __webpack_public_path__ + "static/media/sadiq.7e765c46.jpg";